import React, {
  createContext,
  useContext,
  useState,
  useCallback,
} from 'react';

// Estado global do MODO SIMULADOR (dados fake temporarios pra formatar
// layout). Persistido em localStorage pra sobreviver a reload. So o botao
// do dev (ver isDeveloper) liga/desliga; qualquer tela le via useSimulator.

const STORAGE_KEY = 'cco:simulator';

const SimulatorContext = createContext({
  enabled: false,
  toggle: () => {},
  cycle: 0,
});

export const SimulatorProvider = ({ children }) => {
  const [enabled, setEnabled] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });
  // Contador que AVANCA a cada ATIVACAO do simulador. Usado pra ciclar
  // valores de teste (ex.: angulo de inclinacao 45/90/...) — cada vez que
  // liga, mostra a proxima posicao.
  const [cycle, setCycle] = useState(0);

  const toggle = useCallback(() => {
    setEnabled((prev) => {
      const next = !prev;
      if (next) setCycle((c) => c + 1);
      try {
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      } catch {
        // localStorage indisponivel (modo privado) — mantem so em memoria.
      }
      return next;
    });
  }, []);

  return (
    <SimulatorContext.Provider value={{ enabled, toggle, cycle }}>
      {children}
    </SimulatorContext.Provider>
  );
};

export const useSimulator = () => useContext(SimulatorContext);
